import React from 'react'
import PropTypes from 'prop-types'
import Block from '../Block'
import Lock from '../../Lock'
import { FormattedMessage } from 'react-intl'
import RefiMessages from '../../InterestSection/RefiByYearsInHome/RefiMessages'
import Headline from './Headline'
import Savings from './Savings'
import RateList from './RateList'
import { Text } from '../../..'

import styles from './RefiOptionHeader.module.scss'

const propTypes = {
  className: PropTypes.string,
}

const RefiOptionHeader = ({
  type,
  years,
  rate,
  apr,
  longterm,
  caution,
  locked,
  ...restProps
}) => (
  <Block {...restProps}>
    <Headline>
      <RefiMessages.LoanName type={type} years={years} />
    </Headline>
    <Lock className={styles.savings} enabled={locked}>
      <Savings caution={caution}>{longterm}</Savings>
      {caution && (
        <Text
          className={styles.armCaution}
          size='s'
          variant={longterm <= 0 ? 'danger' : 'warning'}
          weight='semibold'
        >
          {longterm > 0 && (
            <FormattedMessage
              id='Refinance.savings.armLock.caution'
              defaultMessage='Saved Over {years} Years'
              values={{ years }}
            />
          )}
          {longterm <= 0 && (
            <FormattedMessage
              id='Refinance.savings.armLock.bad'
              defaultMessage='Lost Over {years} Years'
              values={{ years }}
            />
          )}
        </Text>
      )}
    </Lock>
    <RateList rate={rate} apr={apr} size='xxs' />
  </Block>
)

RefiOptionHeader.propTypes = propTypes

export default RefiOptionHeader
